import { BREAKPOINT, VIEW_MODE } from '../constant'
import React from 'react'
import config from '../config'

export const handleClickMenu = (menu, mode) => {
  if (!menu) return
  let currentLink = window.location.href
  let arrCurrentLink = currentLink.split(process.env.REACT_APP_BASE_PATH)
  let basePath = `${arrCurrentLink[0]}${process.env.REACT_APP_BASE_PATH}`
  let url = ''
  if (mode === VIEW_MODE.PREVIEW) {
    url = `${basePath}/xemtruoc/${menu}`
  } else {
    url = `${basePath}/${menu}`
  }
  window.history.replaceState(null, null, url)
  const element = document.getElementById(menu)
  if (!element) return
  const rect = element.getBoundingClientRect()
  window.scrollTo({
    top: rect.top + scrollY - 60,
    left: 0,
    behavior: 'smooth',
  })
}
export const renderImageByBreakPoint = (breakPoint, { computer, tablet, mobile }) => {
  switch (breakPoint) {
    case BREAKPOINT.XXL:
    case BREAKPOINT.XL:
    case BREAKPOINT.LG:
      return computer
    case BREAKPOINT.MD:
      return tablet
    case BREAKPOINT.SM:
    case BREAKPOINT.XS:
      return mobile
    default:
      return
  }
}
export const buildPath = path => config.mediaUrl + path